export default {
  odersCustomerId: state => state.odersCustomerId,
  odersCustomer: state => odersCustomerId => state.odersCustomer[odersCustomerId]
}
